import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#CE0000" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink href="https://www.facebook.com/Mikisesamesushi/">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Miki's Sesame Sushi Facebook"
              />
            </CFLink>
            {/* <CFLink href="https://www.yelp.ca/biz/ogenki-sushi-vancouver">
              <CFImage w="40px" pr="10px" src={yelp} alt="Miki's Sesame Sushi Yelp" />
            </CFLink>
            <CFLink href="https://www.zomato.com/vancouver/ogenki-sushi-riley-park-little-mountain-vancouver">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="Miki's Sesame Sushi Zomato"
              />
            </CFLink> */}
            {/* <CFLink href="https://www.instagram.com/mtfujisushi_ladner/">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Miki's Sesame Sushi Instagram"
              />
            </CFLink> */}
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#CE0000" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink href="https://www.facebook.com/Mikisesamesushi/">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Miki's Sesame Sushi Facebook"
                hover
              />
            </CFLink>
            {/* <CFLink href="https://www.yelp.ca/biz/ogenki-sushi-vancouver">
              <CFImage
                w="40px"
                pr="10px"
                src={yelp}
                alt="Miki's Sesame Sushi Yelp"
                hover
              />
            </CFLink>
            <CFLink href="https://www.zomato.com/vancouver/ogenki-sushi-riley-park-little-mountain-vancouver">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="Miki's Sesame Sushi Zomato"
                hover
              />
            </CFLink> */}
            {/* <CFLink href="https://www.instagram.com/mtfujisushi_ladner/">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Miki's Sesame Sushi Instagram"
                hover
              />
            </CFLink> */}
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
